import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  division: {
    fontSize: 14,

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
}))

const divisionDescriptions = {
  JRL_13U(minAge, maxAge) {
    if (minAge && maxAge) {
      return `13U (ages ${minAge}-${maxAge})`
    }
    return '13U (ages 13 and younger)'
  },
  JRL_17U(minAge, maxAge) {
    if (minAge && maxAge) {
      return `17U (ages ${minAge}-${maxAge})`
    }
    return '17U (ages 14-17)'
  },
}

export default function Division({ hit }) {
  const classes = useStyles()

  return (
    <Typography variant="subtitle1" className={classes.division}>
      {divisionDescriptions[hit.division](hit.min_age, hit.max_age)}
    </Typography>
  )
}
